import axios from 'axios'
import { apiURL, uploadCloudTimeout } from './constants'
// import { refreshStorage, getUserUUID } from './LocalStorage'
import { getUserUUID, refreshUserUUID } from './helpers'
import { statOnToken } from './Stat'
import type {
    TPossibleActions,
    TStatEvent,
    TApiUpload,
    TApiTask,
    TApiCheck,
    TApiStat,
    TFilesDropBox,
    TFilesOneDrive,
    TFilesGoogleDrive,
    TTaskType,
    TTaskData,
} from './types'

const UPLOAD_HEADERS = {
    'Content-Type': 'multipart/form-data',
}

const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
}


// Файлы
export const sendUploadFiles = (
    files: File[],
    progressCallback: (e:number) => void,
    action: string,
) => {
    const endpointUrl = `${apiURL}/upload/`

    const data = new FormData()
    files.map(file => data.append('files', file))
    data.append('data', JSON.stringify({
        user_uuid: getUserUUID(),
        action: action,
        source: 'device'
    }))

    return axios.post<TApiUpload>(
        endpointUrl,
        data,
        {
            headers: UPLOAD_HEADERS,
            onUploadProgress: (event) => progressCallback(
                Math.round((event.loaded * 100) / event.total)
            )
        }
    ).then(response => {
        if (response.data.status !== 'error') {
            refreshUserUUID(response.data)
        }
        return response.data
    })
}

// Local
export const sendUploadLocal = (
    token: string,
    action: TPossibleActions,
    source: "local" | "collection" = "local"
) => {   
    const endpointUrl = `${apiURL}/upload/`

    const data = new FormData()
    data.append('cloud_urls', JSON.stringify([token]))
    data.append('data', JSON.stringify({
        user_uuid: getUserUUID(),
        action: action,
        source: source
    }))

    return axios.post<TApiUpload>(
        endpointUrl,
        data,
        {
            headers: UPLOAD_HEADERS,
            timeout: uploadCloudTimeout,
        }
    ).then(response => {
        if (response.data.status !== 'error') {
            refreshUserUUID(response.data)
            statOnToken(action, source === "collection" ? 'template' : 'token')
        }
        return response.data
    })
}

// OneDrive
export const sendUploadOneDrive = (
    files: TFilesOneDrive[],
    progressCallback: (e: number) => void,
    action: string,
) => {
    const endpointUrl = `${apiURL}/upload/`

    const data = new FormData()
    data.append('cloud_urls', JSON.stringify(files))
    data.append('data', JSON.stringify({
        user_uuid: getUserUUID(),
        action: action,
        source: 'onedrive'
    }))

    return axios.post<TApiUpload>(
        endpointUrl,
        data,
        {
            headers: UPLOAD_HEADERS,
            timeout: uploadCloudTimeout,
        }
    ).then(response => {
        if (response.data.status !== 'error') {
            refreshUserUUID(response.data)
        }
        return response.data
    })
}

// DropBox
export const sendUploadDropBox = (
    files: TFilesDropBox[],
    progressCallback: (e: number) => void,
    action: string,
) => {
    const endpointUrl = `${apiURL}/upload/`

    const data = new FormData()
    data.append('cloud_urls', JSON.stringify(files))
    data.append('data', JSON.stringify({
        user_uuid: getUserUUID(),
        action: action,
        source: 'dropbox'
    }))

    return axios.post<TApiUpload>(
        endpointUrl,
        data,
        {
            headers: UPLOAD_HEADERS,
            timeout: uploadCloudTimeout,
        }
    ).then(response => {
        if (response.data.status !== 'error') {
            refreshUserUUID(response.data)
        }
        return response.data
    })
}

// Google Drive
export const sendUploadGoogleDrive = (
    files: TFilesGoogleDrive[],
    progressCallback: (e: number) => void,
    action: string,
) => {
    const endpointUrl = `${apiURL}/upload/`

    const data = new FormData()
    data.append('cloud_urls', JSON.stringify(files))
    data.append('data', JSON.stringify({
        user_uuid: getUserUUID(),
        action: action,
        source: 'google_drive'
    }))

    return axios.post<TApiUpload>(
        endpointUrl,
        data,
        {
            headers: UPLOAD_HEADERS,
            timeout: uploadCloudTimeout,
        }
    ).then(response => {
        if (response.data.status !== 'error') {
            refreshUserUUID(response.data)
        }
        return response.data
    })
}

export const sendTask = (
    payload: TTaskData,
    action: string,
) => {
    const endpointUrl = `${apiURL}/task/`

    const data = {
        user_uuid: getUserUUID(),
        action: action,
        ...payload,
    }

    return axios.post<TApiTask>(
        endpointUrl,
        JSON.stringify(data),
        {
            headers: DEFAULT_HEADERS
        }
    ).then(response => {
        if (response.data.status !== 'error') {
            refreshUserUUID(response.data)
        }
        return response.data
    })
}

export const check = (
    taskUuid: string,
    task_type?: TTaskType,
) => {
    const endpointUrl = `${apiURL}/check/`

    const data: {
        user_uuid: string | null,
        task_uuid: string,
        task_type?: TTaskType,
    } = {
        user_uuid: getUserUUID(),
        task_uuid: taskUuid,
    }

    if (task_type) data.task_type = task_type

    return axios.post<TApiCheck>(
        endpointUrl,
        JSON.stringify(data),
        {
            headers: DEFAULT_HEADERS
        }
    ).then(response => {
        if (response.data.status !== 'error') {
            refreshUserUUID(response.data)
        }
        return response.data
    })
}

export const stat = ({
    action,
    event,
}: {
    action?: TPossibleActions,
    event: TStatEvent,
}) => {
    const endpointUrl = `${apiURL}/stat/`

    const data = {
        user_uuid: getUserUUID(),
        action: action ? action : null,
        event: event,
        performance: Math.round(window?.performance?.now() ? window.performance.now() : 0),
    }

    axios.post<TApiStat>(
        endpointUrl,
        JSON.stringify(data),
        {
            headers: DEFAULT_HEADERS
        }
    ).then(response => {
        if (response.data.status !== 'error' && !getUserUUID()) {
            refreshUserUUID(response.data)
        }
        return response.data
    })
}